import React, { useEffect } from 'react'
import { Table } from '@imcva/reactstrap-table'
import { columnsFn } from './columns'
import { useCardContext } from 'src/components/Card/CardContext'
import { useContracts, useContractStatuses } from 'src/queries'
import { notEmpty } from 'src/helpers/formHelpers'

const Body: React.FC = (props) => {
  const contracts = useContracts({ withPositionCount: true })
  const statuses = useContractStatuses()
  const card = useCardContext()
  const count = contracts.length
  const columns = React.useMemo(() => {
    const statusNames = statuses.map((s) => s.name).filter(notEmpty)
    return columnsFn(statusNames)
  }, [statuses])
  useEffect(() => {
    card.setTitle(`Contracts (${String(count)})`)
  }, [count])
  return (
    <Table storageKey='cat-contracts' options={{ data: contracts, columns, initialState: { sorting: [{ id: 'abbreviation', desc: false }] } }} />
  )
}

export default Body
